import { useState } from 'react';
import { FallbackProps } from 'react-error-boundary';
import Text from '../../atoms/Text';

import './styles.scss';

interface IFallbackProps extends FallbackProps {
  className?: string;
  title: string;
}

function Fallback({
  error,
  resetErrorBoundary,
  className,
  title,
}: IFallbackProps) {
  const [visible, setVisible] = useState(true);
  // Call resetErrorBoundary() to reset the error boundary and retry the render.

  return (
    <div className={className} role='alert' style={{ minHeight: 94 }}>
      <div
        className='fallback_box'
        style={{ opacity: visible ? 1 : 0 }}
        onClick={() => setVisible(!visible)}
      >
        <div className='icon-close' />
        <Text size={14} className='text--white text--weight-600'>
          Oops, there was an error loading {title}:
        </Text>
        <Text size={12} className='text--grey-200 text--weight-500'>
          {error.message}
        </Text>
      </div>
    </div>
  );
}

export default Fallback;
